module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/categories/ovary-e2af559c0796d2d68dcfcfb2b98a5e2d.png";